/**
 * @module Store/view
 * @description Module for back
 */
import Config from '../../api/Config';
import Vue from 'vue';

/**
 * @constant State of orders store
 * @type {Object}
 * */
const state = {
    back: undefined
};

/**
 * @constant Getters
 * @type {Object}
 * */
const getters = {
    getBacdsadk: state => state.back
};

/**
 * @constant Mutations
 * @type {Object}
 * */
const mutations = {
    setBacasdk: (state, payload) => state.back = payload
};

/**
 * @constant Actions
 * @type {Object}
 * */
const actions = {
    productsSaved ({rootState, dispatch}, {id, envData}) {
        const c = new Config({ caller: Vue.axios, rootState, dispatch});
        Vue.axios.get(`/stores/store/${id}`).then(data=>{
            c.productsSaved({setupid: data.data.setupID}, envData);
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
